import PropTypes from 'prop-types'

import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const Step = ({title, subtitle, children}) => {
  return (
    <div className="mt-FormDealerRating-step">
      <TitleBasic as={titleBasicTags.h1} title={title} size={titleBasicSizes.s} />
      {subtitle && <span className="mt-FormDealerRating-stepSubtitle">{subtitle}</span>}
      {children}
    </div>
  )
}

Step.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node
}

export default Step
